import { MetamaskService } from '@/src/services/MetamaskService'
import { Props } from './Layout'

export const useProps = (): Props => {
  return {
    visible: !MetamaskService.isInstalledMetamask(),
    onClickInstall: () => {
      window.open('https://chrome.google.com/webstore/detail/metamask/nkbihfbeogaeaoehlefnkodbefgpgknn')
    },
  }
}
